export default "__VITE_ASSET__BDoxbi4I__"